import { PEOPLE } from './Selectors';

export const VOLUMEN_SPREAD = {
  0: 0.005,
  1: 0.0035,
  2: 0.0015,
  3: 0.001,
};

export const PROVIDERS_SAVINGS = 25;

export const PEOPLE_SAVINGS = {
  [PEOPLE[0].key]: 500,
  [PEOPLE[1].key]: 1000,
  [PEOPLE[2].key]: 1500,
  [PEOPLE[3].key]: 2000,
};
